import $ from "jquery";


const _window           = $(window);
const _body             = $('body');
const _positionTrigger  = 100;
let   _positionCurrent	= 0;
let   _positionLast	    = 0;

const _courseHeaderTrigger  = 500;


const initAppScroll = function(){

    _positionCurrent 			= _window.scrollTop();

    if(_positionCurrent > _positionTrigger) {
        _body.addClass("header--sticky");
        if (_positionLast>_positionCurrent) {
            _body.addClass("header--sticky-up");
        } else {
            _body.removeClass("header--sticky-up");
        }
    } else {
        _body.removeClass("header--sticky");
        _body.removeClass("header--sticky-up");
    }

    if(_positionCurrent > _courseHeaderTrigger) {
        _body.addClass("course--sticky");
        if (_positionLast>_positionCurrent) {
            _body.addClass("course--sticky-up");
        } else {
            _body.removeClass("course--sticky-up");
        }
    } else {
        _body.removeClass("course--sticky");
        _body.removeClass("course--sticky-up");
    }

    _positionLast = _positionCurrent;


};


export const initHeader = function() {

    console.log("Initial Header");
    _window.on('scroll', initAppScroll);

    // Course search toggle
    const searchToggle = $('.course-search-toggle');
    const courseSearch = $('.course-search');
    const searchField = $('.course-search-field');

    searchToggle.on('click', function(e) {
        e.preventDefault();
        courseSearch.toggleClass('course-search-active');
        if (courseSearch.hasClass('course-search-active')) {
            searchField.focus();
        }
    });

    // Close search when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.course-search').length) {
            courseSearch.removeClass('course-search-active');
        }
    });

};